import { api } from './api';

export type NotificationPriority = 'low' | 'medium' | 'high' | 'critical';
export type NotificationType =
  | 'task_due'
  | 'task_overdue'
  | 'prospect_assigned'
  | 'opportunity_stale'
  | 'quote_pending'
  | 'commission_threshold'
  | 'task_assigned_by_direction';

export interface NotificationItem {
  id: string;
  userId: string;
  type: string;
  priority: NotificationPriority;
  title: string;
  message: string | null;
  link: string | null;
  isRead: boolean;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationFilters {
  cursor?: string;
  limit?: number;
  type?: NotificationType;
  priority?: NotificationPriority;
  is_read?: 'true' | 'false';
}

function qs(filters: Record<string, unknown>): string {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v === undefined || v === null || v === '') continue;
    p.set(k, String(v));
  }
  const s = p.toString();
  return s ? `?${s}` : '';
}

function auth(token: string) {
  return { accessToken: token };
}

export const notificationsApi = {
  list: (token: string, filters: NotificationFilters = {}) =>
    api.get<{ data: NotificationItem[]; nextCursor: string | null }>(
      `/api/v1/notifications${qs(filters as Record<string, unknown>)}`,
      auth(token),
    ),
  unreadCount: (token: string) =>
    api.get<{ count: number }>('/api/v1/notifications/unread-count', auth(token)),
  markRead: (token: string, id: string) =>
    api.patch<NotificationItem>(`/api/v1/notifications/${id}/read`, {}, auth(token)),
  markAllRead: (token: string) =>
    api.post<{ updated: number }>('/api/v1/notifications/read-all', {}, auth(token)),
};

export const PRIORITY_LABELS: Record<NotificationPriority, string> = {
  low: 'Faible',
  medium: 'Moyenne',
  high: 'Haute',
  critical: 'Critique',
};

export const PRIORITY_TONES: Record<
  NotificationPriority,
  'neutral' | 'accent' | 'success' | 'warning' | 'danger'
> = {
  low: 'neutral',
  medium: 'accent',
  high: 'warning',
  critical: 'danger',
};

export const TYPE_LABELS: Record<string, string> = {
  task_due: 'Tâche à échéance',
  task_overdue: 'Tâche en retard',
  prospect_assigned: 'Nouveau prospect',
  opportunity_stale: 'Opportunité inactive',
  quote_pending: 'Devis en attente',
  commission_threshold: 'Commission élevée',
  task_assigned_by_direction: 'Tâche direction',
};
